<script setup>
import { computed, onMounted, ref } from 'vue'

import { DragElement } from '@/components/shared/atoms'

const card = ref(null)
const initialX = ref(window.screen.width)
const initialY = ref(window.screen.height)

const props = defineProps({
  size: {
    type: String,
    default: 'regular',
    validate: val => ['small', 'regular'].includes(val)
  }
})

const width = computed(() => (props.size === 'small' ? '400px' : '600px'))

onMounted(() => {
  setInitialPosition()
  setTimeout(() => {
    //delay to load all slot content
    setInitialPosition()
  }, 200)
})

const setInitialPosition = () => {
  const MARGIN = 20
  const offsetHeight = card.value?.offsetHeight
  const offsetWidth = card.value?.offsetWidth
  initialX.value =
    (window.innerWidth || document.body.clientWidth) - offsetWidth - MARGIN
  initialY.value =
    (window.innerHeight || document.body.clientHeight) - offsetHeight - MARGIN
}
</script>

<template>
  <DragElement
    draggable-element-id="header-draggable"
    :initial-x="initialX"
    :initial-y="initialY"
    :width="width"
  >
    <div ref="card" class="float-element">
      <div id="header-draggable"><slot name="header"></slot></div>
      <slot></slot>
    </div>
  </DragElement>
</template>

<style lang="scss" scoped>
.float-element {
  opacity: 1;
  animation: fadeIn 0.8s ease;
  background-color: var(--gl-color-shades-white);
  border-radius: var(--gl-border-radius-md);
  border: var(--gl-border-width-xs) solid var(--gl-color-shades-gray-10);
  box-shadow: var(--gl-shadow-level-01);

  &__body {
    border-radius: 0 0 var(--gl-border-radius-md) var(--gl-border-radius-md);
  }
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  5% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
